import PropTypes from 'prop-types';

const ForwardArrow = (props) => (
  <span className={props.className}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5867 19.1115L9.33334 17.8581L14.2933 12.8892L15.1868 12.0003L14.2933 11.1115L9.33334 6.14257L10.5867 4.88924L17.6978 12.0003L10.5867 19.1115Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

ForwardArrow.defaultProps = {
  className: '',
};

ForwardArrow.propTypes = {
  className: PropTypes.string,
};

export default ForwardArrow;
